import React from "react";
import GumroadFollowForm from "./GumroadFollowForm";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterInner>
        <FooterLeft>
             <Pill as={Link} to="/terms" $variant="ghost">
            Terms & Conditions
          </Pill>
        </FooterLeft>

        <FooterCenter>
          <FormWrap>
            <GumroadFollowForm />
          </FormWrap>
        </FooterCenter>

        <FooterRight>
          <Pill
            as="a"
            href="https://www.instagram.com/spectral_center/"
            target="_blank"
            rel="noopener noreferrer"
            $variant="ghost"
          >
            Instagram
          </Pill>
   
              <Pill
            as="a"
            href="mailto:spectralcenterhypnosis@gmail.com"
            $variant="primary"
          >
            Get in touch
          </Pill>
        </FooterRight>
      </FooterInner>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer`
  width: 100%;
  padding: 2rem 0;
  background: transparent;
  overflow-x: hidden;
`;

const FooterInner = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1rem;

  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: center;

  @media (min-width: 900px) {
    grid-template-columns: auto 1fr auto;
    gap: 2rem;
  }
`;

const FooterLeft = styled.div`
  display: flex;
  justify-content: center;

  @media (min-width: 900px) {
    justify-content: flex-start;
  }
`;

const FooterCenter = styled.div`
  display: flex;
  justify-content: center;
  min-width: 0;
`;

const FooterRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;

  @media (min-width: 900px) {
    justify-content: flex-end;
  }
`;

const FormWrap = styled.div`
  width: 100%;
  max-width: 420px;
  min-width: 0;

  /* keeps whatever the form renders from stretching/overflowing */
  display: flex;
  justify-content: center;

  form {
    width: 100%;
    max-width: 100%;
  }
`;

const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 12px 16px;
  border-radius: 999px;

  border: 2px solid var(--ink, #000);
  /* background: ${(p) =>
    p.$variant === "primary" ? "var(--ink, #000)" : "transparent"};
  color: ${(p) => (p.$variant === "primary" ? "#fff" : "var(--ink, #000)")}; */

  text-decoration: none;
  cursor: pointer;

  font-family: "Agrandir-Regular", sans-serif;
  font-weight: 800;
  font-size: 16px;
  -webkit-text-stroke: 0.1px var(--ink, #000);

  transition: background-color 0.2s ease, transform 0.2s ease, color 0.2s ease;

  &:hover {
    background: rgba(255, 119, 200, 0.18);
    color: var(--ink, #000);
    transform: translateY(-1px);
  }

  @media (min-width: 600px) {
    width: auto;
  }
`;

export default Footer;